import { Essentials } from '@ckeditor/ckeditor5-essentials';
import { Bold, Italic, Underline } from '@ckeditor/ckeditor5-basic-styles';
import { Paragraph } from '@ckeditor/ckeditor5-paragraph';
import { Heading } from '@ckeditor/ckeditor5-heading';
import { List } from '@ckeditor/ckeditor5-list';
import { Link } from '@ckeditor/ckeditor5-link';
import '@/ckeditor5/translations/it';

const editorConfig = ({
    plugins: [
      Essentials,
      Bold,
      Italic,
      Underline,
      Paragraph,
      Heading,
      List,
      Link,
    ],
    toolbar: [
        'heading',
        'bold', 
        'italic',
        'underline',
        '|',
        'undo',
        'redo',
        '|',
        'bulletedList', 'numberedList',
        '|',
        'link',
    ],
});

export default editorConfig;